<template>
    <div
        v-if="shouldShowAuthorization"
        class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-4"
    >
    <div class="flex items-start">
        <div>
        <h3 class="text-lg font-semibold text-yellow-800 mb-2">⚠️ Payment Failed</h3>
        <p class="text-yellow-700">
            Your recent payment was unsuccessful. To avoid additional fees or referral to collections,
            please authorize a new payment on one of the following dates:
        </p>
        </div>
    </div>

    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-4">
        <button
            v-for="(date, index) in availableDates"
            :key="index"
            :class="[
                'rounded px-3 py-2 text-sm border',
                selectedDate === date ? 'bg-yellow-600 text-white border-yellow-700' : 'bg-white text-gray-700 border-gray-300 hover:bg-yellow-100'
            ]"
            :data-testid="`day-${index + 1}`"
            @click="selectedDate = date"
        >
            {{ formatDate(date) }}
        </button>
    </div>

    <button
        @click="authorizePayment"
        type="button"
        class="block w-full no-underline mt-4 bg-yellow-600 hover:bg-yellow-700 border border-yellow-700 rounded text-white text-center text-lg font-semibold py-3 transition-colors duration-200"
        data-testid="authorize-payment-button"
    >
        Authorize Payment
    </button>

    <AppErrorPopup
        :show="showErrorPopup"
        :message="errorMessage"
        @close="closeErrorPopup"
    />
    </div>
</template>

<script>
import AppErrorPopup from "./AppErrorPopup";

export default {
    name: "LoanPaymentAuthorization",
    components: {
        AppErrorPopup,
    },
    props: {
        loan: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedDate: null,
            showErrorPopup: false,
            errorMessage: "",
        };
    },
    computed: {
        shouldShowAuthorization() {
            return (
                this.loan &&
                this.loan.ledger_status === "one_failed_attempt" &&
                Array.isArray(this.loan.payment_authorization_allowed_dates) &&
                this.loan.payment_authorization_allowed_dates.length > 0
            );
        },
        availableDates() {
            return this.loan?.payment_authorization_allowed_dates || [];
        },
    },
    methods: {
        formatDate(dateString) {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const [year, month, day] = dateString.split("-").map(Number);
            return `${monthNames[month - 1]} ${day}`;
        },
        authorizePayment() {
            if (!this.selectedDate) {
                this.errorMessage = "Please select a payment date before proceeding.";
                this.showErrorPopup = true;
                return;
            }

            this.$http
                .post(`/account/loans/${this.loan.id}/authorize-payment`, {
                    date: this.selectedDate,
                })
                .then(() => {
                    this.loan.ledger_status = "enabled";
                })
                .catch((error) => {
                    this.errorMessage =
                    error.response?.data?.message ||
                    "An error occurred while authorizing the payment.";
                    this.showErrorPopup = true;
                });
        },
        closeErrorPopup() {
            this.showErrorPopup = false;
            this.errorMessage = "";
        },
    },
};
</script>